export default __webpack_public_path__ + "static/media/Group9197.a8af0662.svg";